// extracted by mini-css-extract-plugin
export var profile = "TeamProfile-module--profile--ni5mr";
export var imageWrapper = "TeamProfile-module--imageWrapper--182ZL";
export var details = "TeamProfile-module--details--3pa8i";
export var name = "TeamProfile-module--name--3-sxE";
export var role = "TeamProfile-module--role--3-5-j";
export var email = "TeamProfile-module--email--lK8Si";
export var website = "TeamProfile-module--website--1XwOs";